import { NavCardsSection } from "./section-list";
import { useGetCurrentWebpage } from "hooks/useGetCurrentWebpage";

const NavCardsComponentDisplay = () => {
    const webpage = useGetCurrentWebpage();
    const guid = webpage?.guid;
    
    return (
        <div>
            {/*Navigation Cards Component Display*/}
            <NavCardsSection
                webpage_guid={guid}
            />
        </div>
    );
};
NavCardsComponentDisplay.displayName = "NavCardsComponentDisplay";
export { NavCardsComponentDisplay }; 